import { render } from "./CadastrarCategoria.vue?vue&type=template&id=95021cda&scoped=true"
import script from "./CadastrarCategoria.vue?vue&type=script&lang=js"
export * from "./CadastrarCategoria.vue?vue&type=script&lang=js"

import "./CadastrarCategoria.vue?vue&type=style&index=0&id=95021cda&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95021cda"]])

export default __exports__